import React from 'react';
import { IconProps } from './types';

const NoActiveTaskIcon: React.FC<IconProps> = props => {
  const { height = 134, width = 184 } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={`"0 0 ${width} ${height}`}
      fill="none"
    >
      <path
        d="M65.4016 6.57085L3.41047 19.7475C1.68178 20.1149 0.578268 21.8142 0.945713 23.5429L21.1373 118.537C21.5047 120.265 23.204 121.369 24.9327 121.001L86.9237 107.825C88.6524 107.457 89.7559 105.758 89.3885 104.029L69.1969 9.03561C68.8295 7.30692 67.1302 6.20341 65.4016 6.57085Z"
        fill="white"
        stroke="black"
        strokeWidth="0.25"
        strokeMiterlimit="10"
      />
      <path
        d="M14.6276 87.8984L82.8788 73.3912L89.3914 104.031C89.759 105.76 88.656 107.458 86.9267 107.826L24.9356 121.003C23.2062 121.37 21.5078 120.267 21.1402 118.538L14.6276 87.8984Z"
        fill="#E6E7E9"
        stroke="black"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M44.868 62.376C54.144 60.404 60.064 51.288 58.092 42.012C56.12 32.736 47.004 26.816 37.728 28.788C28.452 30.76 22.532 39.876 24.504 49.152C26.476 58.428 35.592 64.348 44.868 62.376Z"
        fill="white"
        stroke="black"
        strokeWidth="0.25"
        strokeMiterlimit="10"
      />
      <path
        d="M56.4519 53.644C54.1519 57.968 50.0319 61.276 44.8679 62.376C39.7039 63.476 34.5959 62.128 30.7319 59.112C31.9119 53.752 36.1079 49.304 41.8279 48.088C47.5479 46.872 53.1919 49.228 56.4519 53.648V53.644Z"
        fill="#E6E7E9"
        stroke="black"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M41.3241 45.7C44.3721 45.052 46.3201 42.056 45.672 39.004C45.024 35.956 42.0281 34.008 38.9761 34.656C35.9281 35.304 33.9801 38.3 34.6281 41.352C35.2761 44.404 38.2721 46.348 41.3241 45.7Z"
        fill="#E6E7E9"
        stroke="black"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.3"
        d="M86.768 107.856L45.292 116.672L34.816 13.068L65.248 6.6C67.06 6.212 68.848 7.372 69.228 9.188L89.356 103.868C89.74 105.688 88.584 107.468 86.764 107.852L86.768 107.856Z"
        fill="#12173D"
      />
      <path
        d="M95.6274 107.185L157.618 120.362C159.347 120.729 161.046 119.626 161.414 117.897L181.605 22.9032C181.973 21.1745 180.869 19.4752 179.141 19.1078L117.15 5.93119C115.421 5.56374 113.722 6.66724 113.354 8.39593L93.1626 103.39C92.7952 105.118 93.8987 106.818 95.6274 107.185Z"
        fill="white"
        stroke="black"
        strokeWidth="0.25"
        strokeMiterlimit="10"
      />
      <path
        d="M157.618 120.36L95.6265 107.183C93.8972 106.816 92.7942 105.117 93.1618 103.388L99.6744 72.7486L167.926 87.2558L161.413 117.895C161.045 119.625 159.347 120.728 157.618 120.36Z"
        fill="#E6E7E9"
        stroke="black"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M137.684 61.732C146.96 63.704 156.076 57.784 158.048 48.508C160.02 39.232 154.1 30.116 144.824 28.144C135.548 26.172 126.432 32.092 124.46 41.368C122.488 50.644 128.408 59.76 137.684 61.732Z"
        fill="white"
        stroke="black"
        strokeWidth="0.25"
        strokeMiterlimit="10"
      />
      <path
        d="M151.82 58.468C147.96 61.484 142.852 62.832 137.684 61.732C132.516 60.632 128.4 57.324 126.1 53C129.356 48.584 135 46.224 140.724 47.44C146.444 48.656 150.644 53.104 151.82 58.464V58.468Z"
        fill="#E6E7E9"
        stroke="black"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M141.228 45.06C144.276 45.708 147.276 43.76 147.924 40.712C148.572 37.664 146.624 34.664 143.576 34.016C140.528 33.368 137.528 35.316 136.88 38.364C136.232 41.412 138.18 44.412 141.228 45.06Z"
        fill="#E6E7E9"
        stroke="black"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.3"
        d="M154.72 101.564C154.6 101.44 154.416 101.38 154.184 101.38C153.32 101.38 151.748 102.2 149.968 103.56L144.384 97.82C155.836 84.964 155.576 65.252 143.38 52.72C134.324 43.412 121.132 40.568 109.544 44.264C108.16 44.616 106.788 45.056 105.452 45.6L103.684 53.904C108.008 50.756 113.04 49.052 118.132 48.768C125.108 48.88 132.04 51.644 137.288 57.04C142.456 62.352 145.032 69.228 145.032 76.1C145.032 82.972 142.264 90.352 136.752 95.712C135.208 97.216 133.528 98.5 131.76 99.564C129.988 100.628 128.124 101.472 126.204 102.096C117.156 104.352 107.188 101.876 100.212 94.716C98.604 93.064 97.252 91.264 96.152 89.352L94.1 99.012L94.12 99.032C100.976 106.076 110.22 109.384 119.316 108.936C126.52 109.004 133.748 106.732 139.768 102.108L145.404 107.9C143.576 110.064 142.632 111.924 143.196 112.516L148.884 118.508L157.468 120.332C159.28 120.72 161.068 119.56 161.452 117.744L163.032 110.312L154.724 101.564H154.72Z"
        fill="#12173D"
      />
      <path
        d="M128.268 0.883972H51C49.2327 0.883972 47.8 2.31666 47.8 4.08397V121.812C47.8 123.579 49.2327 125.012 51 125.012H128.268C130.035 125.012 131.468 123.579 131.468 121.812V4.08397C131.468 2.31666 130.035 0.883972 128.268 0.883972Z"
        fill="white"
        stroke="black"
        strokeWidth="0.25"
        strokeMiterlimit="10"
      />
      <path
        d="M47.8 83.612H131.468V121.808C131.468 123.576 130.036 125.008 128.268 125.008H51C49.232 125.008 47.8 123.576 47.8 121.808V83.612Z"
        fill="#E6E7E9"
        stroke="black"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M89.636 61.216C101.008 61.216 110.224 52 110.224 40.628C110.224 29.256 101.008 20.04 89.636 20.04C78.264 20.04 69.048 29.256 69.048 40.628C69.048 52 78.264 61.216 89.636 61.216Z"
        fill="white"
        stroke="black"
        strokeWidth="0.25"
        strokeMiterlimit="10"
      />
      <path
        d="M105.4 53.864C101.62 58.364 95.968 61.216 89.636 61.216C83.304 61.216 77.6479 58.364 73.8719 53.864C76.5919 47.872 82.624 43.7 89.636 43.7C96.648 43.7 102.684 47.872 105.4 53.864Z"
        fill="#E6E7E9"
        stroke="black"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M89.636 40.78C93.372 40.78 96.404 37.748 96.404 34.012C96.404 30.276 93.372 27.244 89.636 27.244C85.9 27.244 82.868 30.276 82.868 34.012C82.868 37.748 85.9 40.78 89.636 40.78Z"
        fill="#E6E7E9"
        stroke="black"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.3"
        d="M118.128 44.568C122.752 44.644 127.356 45.884 131.468 48.284V40.672C124.444 37.992 116.688 37.784 109.54 40.064C104.148 41.436 99.032 44.188 94.756 48.348C81.744 61.008 81.452 81.82 94.112 94.836C100.968 101.88 110.212 105.188 119.308 104.74C123.432 104.776 127.56 104.052 131.464 102.556V95.528C129.776 96.516 128.012 97.304 126.196 97.896C117.148 100.152 107.18 97.676 100.204 90.516C89.764 79.788 90.004 62.632 100.728 52.196C105.612 47.448 111.82 44.92 118.124 44.572L118.128 44.568Z"
        fill="#12173D"
      />
      <path
        d="M183.444 121.624L157.016 94.664L145.664 105.792L172.092 132.752C172.86 133.536 176.028 131.68 179.16 128.608C182.296 125.536 184.212 122.408 183.444 121.624Z"
        fill="#0087FF"
        stroke="black"
        strokeWidth="0.25"
        strokeMiterlimit="10"
      />
      <path
        d="M152.731 101.643C155.865 98.5702 157.783 95.4436 157.015 94.6595C156.246 93.8755 153.082 95.7309 149.947 98.8038C146.813 101.877 144.895 105.003 145.663 105.787C146.432 106.571 149.596 104.716 152.731 101.643Z"
        fill="#12173D"
        stroke="black"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M153.24 97.676L144.008 88.48L139.564 92.944L148.784 102.128C149.044 102.388 149.444 102.448 149.768 102.276C150.332 101.976 151.216 101.452 151.888 100.788C152.604 100.084 153.116 99.204 153.4 98.644C153.564 98.32 153.496 97.932 153.24 97.676Z"
        fill="#E6E7E9"
        stroke="black"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M138.956 89.088C149.616 78.384 149.584 61.072 138.888 50.412C128.184 39.752 110.868 39.788 100.208 50.484C89.5481 61.188 89.5801 78.5 100.28 89.164C110.984 99.82 128.292 99.784 138.952 89.088H138.956ZM96.2961 46.584C109.108 33.72 129.924 33.684 142.788 46.5C155.652 59.312 155.688 80.128 142.872 92.992C130.06 105.856 109.244 105.892 96.3801 93.076C83.5161 80.264 83.4801 59.448 96.2961 46.584Z"
        fill="#545454"
        stroke="black"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.5"
        d="M140.72 88.588C130.16 99.184 113.008 99.22 102.404 88.66C91.8 78.096 91.768 60.94 102.332 50.336C112.892 39.74 130.052 39.7 140.656 50.264C151.252 60.824 151.284 77.98 140.72 88.584V88.588Z"
        fill="white"
      />
      <path
        d="M144.912 45.996C131.948 33.084 110.976 33.12 98.064 46.084C85.152 59.048 85.188 80.02 98.152 92.932C111.116 105.844 132.088 105.808 145 92.844C157.912 79.884 157.876 58.908 144.912 45.996ZM140.72 88.588C130.16 99.184 113.008 99.22 102.404 88.66C91.8 78.096 91.768 60.94 102.332 50.336C112.892 39.74 130.052 39.7 140.656 50.264C151.252 60.824 151.284 77.98 140.72 88.584V88.588Z"
        fill="white"
        stroke="black"
        strokeWidth="0.25"
        strokeMiterlimit="10"
      />
    </svg>
  );
};
export default NoActiveTaskIcon;
